import '../Core/scripts/sitewide';
import '../Core/scss/_footer.scss';
import '../Core/scripts/sidebar.js';
import './style.scss';


document.addEventListener('DOMContentLoaded', () => {
    if (window.location.pathname.includes('questions')) {
        import('../Questions/style.scss');
    }
})